// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"59ddf828","157":"796676d1","660":"493448b8","664":"aebf7610","675":"a65dc31f"}[chunkId] + ".chunk.js";
};